import { X } from 'lucide-react';
import type { ProjectFile } from '../../types/project';
import { MIST_LANGUAGE_ID } from '../../editor/mistLanguage';
import styles from './EditorTabs.module.css';

interface EditorTabsProps {
  files: ProjectFile[];
  activeFileId: string | null;
  onSelect: (fileId: string) => void;
  onClose: (fileId: string) => void;
}

export function EditorTabs({ files, activeFileId, onSelect, onClose }: EditorTabsProps) {
  if (files.length === 0) return null;

  return (
    <div className={styles.tabBar}>
      {files.map(file => (
        <div
          key={file.id}
          className={`${styles.tab} ${file.id === activeFileId ? styles.activeTab : ''}`}
        >
          <button
            className={styles.tabLabel}
            onClick={() => onSelect(file.id)}
            title={file.path}
          >
            {file.isModified && <span className={styles.modifiedDot} />}
            {file.language === MIST_LANGUAGE_ID && <span className={styles.langBadge}>Mist</span>}
            {file.name}
          </button>
          <button
            className={styles.closeBtn}
            onClick={(e) => { e.stopPropagation(); onClose(file.id); }}
            title="Close"
            aria-label={`Close ${file.name}`}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
